<script setup lang="ts">
import { computed, ComputedRef, defineProps, withDefaults, Ref, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import ContextMenu from '@/dashboard/vue/components/common/ContextMenu/ContextMenu.vue';

const props = withDefaults(
  defineProps<{
    titleClass?: string;
    bodyClass?: string;
    needTeleport?: boolean;
  }>(),
  {
    titleClass: '',
    bodyClass: '',
    needTeleport: false,
  }
);

const slots = defineSlots<{
  title(props: { isOpen: boolean }): any;
  body(props: object): any;
}>();

const isOpen: Ref<boolean> = ref(false);
const titleButton: Ref<HTMLDivElement | undefined> = ref();
const position = ref({
  left: 0,
  top: 0,
});

function open() {
  isOpen.value = true;
  const { x: left = 0, y, height } = titleButton.value?.getBoundingClientRect() || {};
  position.value = { left, top: (y || 0) + (height || 0) };
}

onClickOutside(titleButton, (event) => {
  setTimeout(() => (isOpen.value = false), 10);
});
</script>

<template>
  <div class="relative">
    <div ref="titleButton" class="cursor-pointer" :class="props.titleClass" @click="() => open()">
      <slot name="title" :is-open="isOpen"></slot>
    </div>

    <Teleport v-if="props.needTeleport" to="body">
      <ContextMenu v-if="isOpen" :class="props.bodyClass" class="!fixed" :style="{ left: position.left, top: position.top }" role="menu">
        <template #body>
          <slot name="body"></slot>
        </template>
      </ContextMenu>
    </Teleport>

    <ContextMenu v-else-if="!props.needTeleport && isOpen" :class="props.bodyClass" role="menu">
      <template #body>
        <slot name="body"></slot>
      </template>
    </ContextMenu>
  </div>
</template>
